module.exports = __webpack_public_path__ + "static/media/blockchain.8dca164f.png";